import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

import Card from './card';
import Options from './options';
import SettingsContext from '../settings_context';

export default function SelectedOptions({ options, optionsLabel, reorderable, selection, onChange, onRemoveAll }) {
  const settings = useContext(SettingsContext);

  const selectedOptions = useMemo(() => {
    return selection.map((selectedOption) => {
      return options.find((realOption) => {
        return realOption[settings.optionValueName] === selectedOption[settings.optionValueName];
      });
    }).filter(option => option);
  }, [options, selection]);

  let control;
  if (selection.length) {
    control = (
      <a className="clickable" onClick={onRemoveAll ? onRemoveAll : () => onChange([])}>
        Remove All
      </a>
    );
  }

  function moveSelection(sourceIndex, targetIndex) {
    const option = selection[sourceIndex];
    selection = [...selection.slice(0, sourceIndex), ...selection.slice(sourceIndex + 1)];
    selection.splice(targetIndex, 0, option);
    onChange(selection);
  }

  return (
    <Card
      control={control}
      header={`Selected ${optionsLabel}`}
    >
      <Options
        options={selectedOptions}
        reorderable={reorderable}
        selected
        onOptionClick={(removed) => {
          return onChange(selection.filter((option) => {
            return option[settings.optionValueName] !== removed[settings.optionValueName];
          }));
        }}
        onOptionMove={moveSelection}
      />
    </Card>
  );
}

SelectedOptions.propTypes = {
  options: PropTypes.array.isRequired,
  optionsLabel: PropTypes.string,
  reorderable: PropTypes.bool,
  selection: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  onRemoveAll: PropTypes.func,
};
